module.exports = __webpack_public_path__ + "img/care-restoring.8426e72c.png";